// extracted by mini-css-extract-plugin
export default {"container":"LiveVision_container__ckH23","topBar":"LiveVision_topBar__3RLMU","icon":"LiveVision_icon__PI7DM","closeIconContainer":"LiveVision_closeIconContainer__E2dP3"};